// v4 — Goal Studio (set goals)
import React, { useState } from 'react';
import { v4data, GOALS } from './v4data';
import { PageHeader, Card, Insight, fmt$, fmtK, fmtN, fmtX } from './v4ui';
import MarkPopup from './MarkPopup';
import './dashboard.scss';

export default function GoalStudioV4() {
  const D = v4data(30);
  const [g, setG] = useState({ revenue: GOALS.revenue, mer: GOALS.mer, aov: GOALS.aov });
  const set = (k) => (e) => setG({ ...g, [k]: parseFloat(e.target.value) || 0 });

  const adspend = g.mer ? g.revenue / g.mer : 0;
  const orders = g.aov ? g.revenue / g.aov : 0;
  const cpo = orders ? adspend / orders : 0;

  const fields = [
    { k: 'revenue', label: 'Monthly Store Revenue', prefix: '$', step: 10000 },
    { k: 'mer', label: 'Marketing Efficiency Ratio (MER)', suffix: 'x', step: 0.1 },
    { k: 'aov', label: 'Average Order Value', prefix: '$', step: 1 },
  ];
  const derived = [
    { label: 'Required Ad Spend', value: fmtK(adspend), color: '#38bdf8' },
    { label: 'Required Orders', value: fmtN(orders), color: '#5A54F3' },
    { label: 'Target Cost / Order', value: fmt$(cpo), color: '#f472b6' },
    { label: 'Implied ROAS', value: fmtX(g.mer), color: '#8AE8BD' },
  ];

  return (
    <div className="v4-dash">
      <PageHeader title="Goal Studio" sub="Set your targets — everything else is calculated for you" right={<button className="v4-export">Save goals</button>} />

      <MarkPopup inline context="goalstudio" />

      <section className="v4-2col">
        <Card title="Your Goals" sub="Adjust and the plan updates instantly">
          <div className="v4-form">
            {fields.map((f) => (
              <label className="v4-field" key={f.k}>
                <span className="fl">{f.label}</span>
                <span className="fi">
                  {f.prefix && <em>{f.prefix}</em>}
                  <input type="number" value={g[f.k]} step={f.step} onChange={set(f.k)} />
                  {f.suffix && <em>{f.suffix}</em>}
                </span>
              </label>
            ))}
          </div>
        </Card>

        <Card title="Derived Targets" sub="What it takes to hit your goal">
          <div className="v4-derived">
            {derived.map((d) => (
              <div className="v4-derived-item" key={d.label}>
                <span className="dl">{d.label}</span>
                <span className="dv" style={{ color: d.color }}>{d.value}</span>
              </div>
            ))}
          </div>
        </Card>
      </section>

    </div>
  );
}
